import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import InputAdornment, { InputAdornmentProps } from '@mui/material/InputAdornment';

export interface InputErrorAdornmentProps extends InputAdornmentProps {
  hasError?: boolean;
}

export function InputErrorAdornment(props: InputErrorAdornmentProps) {
  const { hasError, children, sx, ...other } = props;

  return (
    <InputAdornment {...other}>
      <PriorityHighIcon
        color="error"
        sx={[
          {
            marginLeft: 1,
          },
          hasError
            ? {
                opacity: 1,
              }
            : {
                opacity: 0,
              },
        ]}
      />
      {children}
    </InputAdornment>
  );
}
